import type { ProjectDescriptionConfig, Locale } from '../../types';
import styles from './ProjectDescriptionCard.module.css';

// Since I didn't check for react-markdown, I'll use simple text rendering with newlines for now to be safe,
// or check package.json. User didn't ask for markdown explicitly but the text has "##".
// Let's implement a simple renderer or just `white-space: pre-wrap` which I did in CSS.
// Actually, the text has markdown-like syntax "##". I'll use simple text display for safety first.
// If user wants markdown rendering, I can add it later. For now, white-space: pre-wrap handles newlines.

interface ProjectDescriptionCardProps {
    config: ProjectDescriptionConfig;
    locale: Locale;
}

export function ProjectDescriptionCard({ config, locale }: ProjectDescriptionCardProps) {
    // Basic Markdown removal/formatting if we aren't using a library
    // For now, let's just render it. The CSS `white-space: pre-wrap` handles the newlines.

    // Helper to process text (e.g. remove markdown headers for cleaner display if needed, 
    // but user wrote "##" so maybe they want it specific.
    // I will render it as is.
    const descriptionText = config.description[locale];

    return (
        <div className={styles.card}>
            <div className={styles.header}>
                <h2 className={styles.title}>{config.title[locale]}</h2>
            </div>

            <div className={styles.content}>
                <div className={styles.description}>
                    {descriptionText}
                </div>

                {config.images && config.images.length > 0 && (
                    <div className={styles.images_grid}>
                        {config.images.map((imgSrc, index) => (
                            <div key={index} className={styles.reference_image_wrapper}>
                                <img
                                    src={imgSrc}
                                    alt={`Reference ${index + 1}`}
                                    className={styles.reference_image}
                                    loading="lazy"
                                />
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}
